var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('section', {
    staticClass: "sub-visual"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap mb-24 mb-md-50 mb-lg-0"
  }, [_c('v-img', {
    staticClass: "tit-wrap__img",
    attrs: {
      "src": "/images/common/tit-img.png"
    }
  }), _c('h2', {
    staticClass: "tit tit--xl"
  }, [_vm._v(" Business ")])], 1)]), _c('v-img', {
    staticClass: "sub-visual__img",
    attrs: {
      "src": "/images/sub/company/sub-visual-company.jpg"
    }
  }), _c('sub-tab', {
    attrs: {
      "page": "회사소개",
      "tabActive": 1
    }
  })], 1), _c('section', {
    staticClass: "sub-section sub-section--greeting"
  }, [_c('v-container', [_c('v-row', {
    staticClass: "justify-space-between",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "5"
    }
  }, [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h3', {
    staticClass: "tit tit--lg font-pretendard line-height-135",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_vm._v(" 안녕하세요."), _c('br'), _vm._v(" (주)모두에프엔티 홈페이지에"), _c('br'), _vm._v(" 방문해 주셔서 감사합니다. ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6",
      "data-aos": "fade-left"
    }
  }, [_c('div', {
    staticClass: "page-text grey--text"
  }, [_c('p', [_vm._v(" MODOO F&T는 모두를 위한 Food & Total 이라는 뜻을 가지고 있으며 26년간의 노하우로 그동안 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 다진 탄탄한 정보망과 네트워크를 통해 각종 업체들에게 2,000가지의 다양한 카테고리의 제품을 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 공급하여 맞춤화 서비스를 제공해 드립니다. ")]), _c('p', [_vm._v(" 모두에프엔티는 최상의 식재료 품질과 체계적 유통 시스템으로 고객 만족을 실현하고 있습니다. "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" One stop shopping 으로 한번에 식자재 세팅을 위해 경쟁력 있는 가격, 그리고 신뢰를 바탕으로 한 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 기업간의 협업으로 양질의 상품을 전달합니다. ")]), _c('p', [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("\"모두가 잘 먹고 잘 살 수 있다면\"")]), _c('br'), _vm._v(" 모두에프엔티가 꿈꾸는 세상은 우리 모두가 잘 먹고 잘 사는 세상입니다. ")]), _c('p', [_vm._v(" 단순히 식재료를 전달하는 것 이상으로, 고객에겐 건강한 라이프스타일의 가치를 전달하고 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 파트너사와는 함께 상생하는 기업으로서 성장하고자 합니다. ")]), _c('p', [_vm._v(" 모두와 함께하는 모두에게 건강한 행복을 선물하겠습니다."), _c('br'), _vm._v(" 감사합니다. ")])])])], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }